import { FeedbackResult } from '@/interfaces/feedback';
import { InitStoreType } from '@/types/store/init';
import { GetCallbackParamsData } from '@/utils/common';

export interface CommonPropsType {
  dialogueId: string;
  dialogueType: string;
}

export enum DIALOGUE_FROM {
  /** 用户发送 */
  USER = 'user',
  /** taskbot发送 */
  BOT = 'bot',
  /** 前端生成的提示 */
  SYSTEM = 'system',
  /** 客服消息 */
  AGENT = 'agent',
}

export enum DIALOGUE_TYPE {
  Msg = 'Msg',
  SingleArticle = 'SingleArticle',
  MultiArticle = 'MultiArticle',
  Options = 'Options',
  Feedback = 'Feedback',
  Redirection = 'Redirection',
  Live = 'Live',
  OrderList = 'OrderList',
  QAButton = 'QAButton',
  Login = 'Login',
  General = 'General',
  NegativeOptions = 'NegativeOptions',
  StateTransactionList = 'StateTransactionList',
  OrderCardWithHQ = 'OrderCardWithHQ',
  HotQuestions = 'HotQuestions',
  Announcements = 'Announcements',
  EnquiryDetails = 'EnquiryDetails',
  DateTime = 'DateTime',
  IntentHotQuestion = 'IntentHotQuestion',
  HotQuestionCategory = 'HotQuestionCategory',
  NewHotQuestion = 'NewHotQuestion',
  OrderCardWithSN = 'OrderCardWithSN',
  SPLater = 'SPLater',
  MySupportCase = 'MySupportCase',
  IntentSelector = 'IntentSelector',
  Image = 'Image',
  HistoryImage = 'HistoryImage',
  IDK = 'IDK',
  LiveAgentRecommender = 'LiveAgentRecommender',
  Order = 'Order',
  Transaction = 'Transaction',
  Video = 'Video',
  TASK = 'TASK',
  CC = 'CC', // Chit Chat 闲聊
  QuestionsList = 'QuestionsList',
  AgentTip = 'AgentTip',
  AgentEnter = 'AgentEnter',
  AgentLeave = 'AgentLeave',
  AgentTime = 'AgentTime',
  ChatTransfer = 'ChatTransfer',
  FileUpload = 'FileUpload',
  SessionEnd = 'SessionEnd',
  SessionTimeout = 'SessionTimeout',
  SessionTransfer = 'SessionTransfer',
  Tip = 'Tip',
  OrderTipMsg = 'OrderTipMsg',
  OrderSelectionFAQ = 'OrderSelectionFAQ',
  UnreadMessages = 'UnreadMessages',
  UserCloseSession = 'UserCloseSession',
  CustomOptions = 'CustomOptions',
  SystemNotice = 'SystemNotice',
  WebFormPreview = 'WebFormPreview',
  TFEOrderList = 'TFEOrderList',
  TFETransactionList = 'TFETransactionList',
  TFEOrder = 'TFEOrder',
  TFEFoodBuyerOrder = 'TFEFoodBuyerOrder',
  TFEModal = 'TFEModal',
  TFECancelOrder = 'TFECancelOrder',
  TFEGuaranteeModal = 'TFEGuaranteeModal',
  TFETransaction = 'TFETransaction',
  TFEMessage = 'TFEMessage',
  TFESystemMessage = 'TFESystemMessage',
  TipMessage = 'TipMessage',
  TFEArticle = 'TFEArticle',
  QA = 'QA',
  OrderCardWithButton = 'OrderCardWithButton',
  CaseCard = 'CaseCard',
  OrderSelector = 'OrderSelector',
  FoodOrder = 'FoodOrder',
  ProbingFormPreview = 'ProbingFormPreview',
  ChannelOptionLive = 'ChannelOptionLive',
  KeyAnswer = 'KeyAnswer',
  OrderListIntentSelector = 'OrderListIntentSelector',
  SystemText = 'SystemText',
  OrderWithConfirmation = 'OrderWithConfirmation',
  PopUpAnnouncementModal = 'PopUpAnnouncementModal',
  TFEContactCourierCard = 'TFEContactCourierCard',
  BasedActionHandle = 'BasedActionHandle',
  EnquiryCaseCard = 'EnquiryCaseCard',
  Message = 'Message',
  Button = 'Button',
  ChannelOptionsMessage = 'ChannelOptionsMessage',
  TFEExpediteDeliveryModal = 'TFEExpediteDeliveryModal',
  TFEExpediteDeliverySuccessCard = 'TFEExpediteDeliverySuccessCard',
  TFEDeliveryInstructionCard = 'TFEDeliveryInstructionCard',
  TFEDeliveryInstructions = 'TFEDeliveryInstructions',
  TFERelatedIntent = 'TFERelatedIntent',
  FacialVerification = 'FacialVerification'
}

/** inhouse消息类型 */
export enum INHOUSE_MESSAGE_TYPE {
  TEXT = 'TEXT',
  IMG = 'IMG',
  FILE = 'FILE',
  VID = 'VID',
  ORDER = 'ORDER',
  NEW_SESSION = 'NEW_SESSION',
  TRANSFER_SESSION = 'TRANSFER_SESSION',
  CS_JOINED = 'CS_JOINED',
  USER_CLOSE_SESSION = 'USER_CLOSE_SESSION',
  CHASING_USER_CLOSE_SESSION = 'CHASING_USER_CLOSE_SESSION',
  CHASING_TIMEOUT_CLOSE_SESSION = 'CHASING_TIMEOUT_CLOSE_SESSION',
  SESSION_CLOSE_TIMEOUT = 'SESSION_CLOSE_TIMEOUT',
  CS_CLOSE_SESSION = 'CS_CLOSE_SESSION',
  QUEUING = 'QUEUING',
  CSAT = 'CSAT',
  CHAT_ENDED = 'CHAT_ENDED',
  SESSION_END = 'SESSION_END',
  AGENT_TYPING = 'AGENT_TYPING',
  AGENT_NOT_TYPING = 'AGENT_NOT_TYPING',
  QUEUING_CHECK_NOTICE = 'QUEUING_CHECK_NOTICE',
  SYSTEM_NOTICE = 'SYSTEM_NOTICE',
  SERVICE_ASSISTANT = 'SERVICE_ASSISTANT',
  FACIAL_VERIFICATION = 'REQUEST_FACIAL_VERIFICATION', // 新增人脸识别消息
  FACIAL_VERIFICATION_SUCCESS = 'FACIAL_VERIFICATION_SUCCESS',
  FACIAL_VERIFICATION_FAILED = 'FACIAL_VERIFICATION_FAILED'
}

export enum ButtonType {
  Url = 1,
  ReplyMsg = 2,
  ChasingChatWithAgent = 3,
}

export enum ButtonActionType {
  None = 0,
  ContinueOnLine = 1,
  ChasingEndChat = 2,
  ChasingChatContinue = 3,
}

export enum ServiceAssistantType {
  ChasingStart = 'CHASING_START_MSG',
  ChasingEnd = 'CHASING_END_MSG',
  IncompleteStart = 'INCOMPLETE_START_MSG',
  IncompleteEnd = 'INCOMPLETE_END_MSG',
}


export enum ChasingEventType {
  AgentCancelChasing = 1,
  ChasingCountdownEnd = 2,
  UserSendYesContinue = 3,
  UserSendNoEndChat = 4,
  UserSendMsg = 5,
  AgentSendMsg = 6,
}

export type Overwrite<T, U> = Pick<T, Exclude<keyof T, keyof U>> & U;

export type TrackerProps = {
  /** refs */
  passedRef: (ele: any, index?: number) => void;
  /** tracker */
  tracker: {
    /** impression tracker */
    impression: {
      /** custom call add observer */
      addObserver: (index?: number) => void;
      /** custom call remove observer */
      removeObserver: () => void;
    };
    /** click tracker */
    click: (data: TrackerClickData) => void;
  };
};

export interface TrackerClickData {
  operation?: string;
  trackingname: string;
  data: any;
}

export interface OrderProps {
  order_id: number | string;
  order_sn: string;
  return_id: string;
  shop_id: number;
  checkout_id: number;
  uri_key: string;
  title: string;
  image: string;
  price: number;
  specification: string;
}

export type ChatbotUIBasicProps = {
  initStore: InitStoreType;
  dialogueId: string;
  dialogueType: string;
  threadNodeId: string;
  threadId: string;
  threadIdV2: string;
  roundId: string;
  isHistory: boolean;
  nodePointId: string;
  historySessionId: string;
  historyDialogueId: string;
  sessionId: string;
  taskbotName: string;
  kbBotId: string;
  kbBotName: string;
  tfNodeId: string;
  tfCaseId: string;
  listPos: number;
  customCallback?: GetCallbackParamsData;
  taskbotInfo: {
    bot_id: number;
    case_id: string;
    task_bot_id: string;
    flow_id: string;
    editor_node_id: string;
    node_id: string;
    tf_node_id: string;
    report_node_id: string;
    node_name: string;
    snapshot_id: string;
  };
  shouldDisplayInstantly?: boolean;
  userInputId?: string;
  outputType?: string[];
};

export enum NEW_HOT_QUESTION_SOURCE {
  kb = 5,
}

export enum ActionType {
  NoAction = 1,
  HideCancelButton = 2,
  HideESGButton = 3, // hide extend shopee guarantee button
}

export const DEFAULT_BUTTON_URL = 'useDefaultUrl';

export enum RRStatus {
  ReturnRequested = 1,
  ReturnAccepted,
  ReturnCanceled,
  ReturnJudging,
  ReturnRefundPaid,
  ReturnClosed,
  ReturnProcessing,
  ReturnSellerDispute,
}

export enum OrderExtStatus {
  ORDER_EXT_DELETE = 0,
  ORDER_EXT_UNPAID = 1,
  ORDER_EXT_PAID = 2,
  ORDER_EXT_SHIPPED = 3,
  ORDER_EXT_COMPLETED = 4,
  ORDER_EXT_INVALID = 6,
  ORDER_EXT_CANCEL_PROCESSING = 7,
  ORDER_EXT_CANCEL_COMPLETED = 8,
  ORDER_EXT_RETURN_PROCESSING = 9,
  ORDER_EXT_RETURN_COMPLETED = 10,
  ORDER_EXT_ESCROW_PAID = 11,
  ORDER_EXT_ESCROW_CREATED = 12,
  ORDER_EXT_ESCROW_PENDING = 13,
  ORDER_EXT_ESCROW_VERIFIED = 14,
  ORDER_EXT_ESCROW_PAYOUT = 15,
  ORDER_EXT_CANCEL_PENDING = 16,
}

export enum InhouseCaseStatus {
  Received = 1,
  InProgress = 2,
  ActionRequired = 3,
  Solved = 4,
  Completed = 5,
}

export interface InhouseCaseEntity {
  id: number;
  status: InhouseCaseStatus;
  title: string;
  order_sn: string;
  order_pic_url: string;
  case_desc: string;
  status_desc: string;
  update_time: number;
  form_schema: string;
  submitted_data: string;
  ui_schema: string;
  enquiry_type: string;
  msg_type: string;
  mail_subject: string;
  create_method: string;
}

export type DomNode = {
  data?: string | undefined;
  type?: string | undefined;
  name?: string | undefined;
  attribs?: { [key: string]: string };
  children?: DomNode[];
  parent?: DomNode;
};

export interface TFERatingInfo {
  // 小写的
  region: string;
  session_id: string;
  dialogue_id: string;
  dm_thread_id: string;
  rating: FeedbackResult;
  // 透传
  task_bot_info: {
    bot_id: number;
    case_id: string;
    task_bot_id: string;
    flow_id: string;
    editor_node_id: string;
    node_id: string;
    tf_node_id: string;
    report_node_id: string;
    node_name: string;
    snapshot_id: string;
  };
}

// [live-chat-split-change]
export enum EventType {
  // SDK相关
  BeforeInit = 'beforeInit',
  Init = 'init',
  Connect = 'connecting',
  Connected = 'connected',
  Queueing = 'queueing',
  Chatting = 'chatting',
  CancelQueue = 'cancelQueue',
  EndChat = 'endChat',
  Quit = 'quit',
  UpdateReadedMessage = 'updateReadedMessage',
  AddMessage = 'addMessage',
  UpdateQueuePosition = 'updateQueuePosition',
  ChatWithAgent = 'chatWithAgent',

  // 页面相关事件
  PopWebView = 'popWebView',
}

export interface ChatUiEventsOptions {
  notDialogue?: boolean;
}
